import {jsonArrayMember, jsonMember, jsonObject} from "typedjson";
import {DxPageHeaderItemOptions} from "./dx-page-header-item-options";


/**
 * Класс опций группы элементов шапки страницы.
 * @publicApi
 */
@jsonObject
export class DxPageHeaderGroupOptions {
  /**
   * Порядок следования гуппы элементов в шапке.
   * @name _ord
   * @type {number}
   * @defaultValue - 0
   */
  @jsonMember({name: "ord", constructor: Number, emitDefaultValue: true, isRequired: false})
  private _ord: number = 0;

  /**
   * Массив элементов шапки, принадлежахих данной группе.
   * @name _items
   * @type {DxPageHeaderItemOptions[]}
   * @defaultValue - пустой массив.
   */
  @jsonArrayMember(DxPageHeaderItemOptions, {name: 'items', isRequired: false, emitDefaultValue: false})
  private _items: DxPageHeaderItemOptions[] = [];

  /**
   * Возвращает порядок следования гуппы элементов в шапке.
   * @return {number} - порядок следования гуппы элементов в шапке.
   * @public
   */
  get ord(): number {
    return this._ord;
  }

  /**
   * Устанавливает порядок следования гуппы элементов в шапке.
   * @param {number} value - порядок следования гуппы элементов в шапке.
   * @public
   */
  set ord(value: number) {
    this._ord = value;
  }

  /**
   * Возвращает массив элементов шапки, принадлежахих данной группе.
   * @return {DxPageHeaderItemOptions[]} - массив элементов в шапки, принадлежахих данной группе.
   * @public
   */
  get items(): DxPageHeaderItemOptions[] {
    return this._items;
  }

  /**
   * Устанавливает массив элементов шапки, принадлежахих данной группе.
   * @param {DxPageHeaderItemOptions[]} value - массив элементов в шапки, принадлежахих данной группе.
   * @public
   */
  set items(value: DxPageHeaderItemOptions[]) {
    this._items = value;
  }
}
